import { encodeHtml } from "./skyward.base.extensions";
import { set as setInternal, registerDistinctMultiSelectEEL } from "./skyward.ui.distinctMultiSelectEEL";

const classNames =
{
    distinctMultiSelectEEL: "distinctMultiSelectEEL",
    eventsBound: "eventsBound--DMSE",
    returnValueListAsKeys: "returnValueListAsKeys"
};

export function get(element: JQuery<HTMLElement>)
{
    const searchParameters: string[] = [];
    const valueList: Record<string, string> = {};

    forEachSelectedValue(element, function (key, value)
    {
        const encodedKey = encodeHtml(key);
        const encodedValue = encodeHtml(value);

        searchParameters.push(encodedKey);
        valueList[encodedKey] = encodedValue;
    });

    if (element.hasClass(classNames.returnValueListAsKeys))
    {
        return searchParameters;
    }

    return valueList;
}

export function set(element: JQuery<HTMLElement>, value: string | object, suppressChangeEvent: boolean = false)
{
    return setInternal(element, value, suppressChangeEvent);
}

export function copyValue(source: JQuery<HTMLElement>, dest: JQuery<HTMLElement>, suppressChangeEvent: boolean = false)
{
    const sourceDmse = registerDistinctMultiSelectEEL(source);
    const destDmse = registerDistinctMultiSelectEEL(dest);
    destDmse.setBackingData(
        { ...sourceDmse.distinctMultiSelectEELData.selectedKeyValuePairs },
        { ...sourceDmse.distinctMultiSelectEELData.selectedKeyValueHashes },
        false,
        suppressChangeEvent);
}

export function getOriginal(element: JQuery<HTMLElement>)
{
    const values: Record<string, string> = element.data("original-value");

    const searchParameters: string[] = [];
    const valueList: Record<string, string> = {};

    // sort values so dirty logic is smarter
    for (const key of Object.keys(values).sort())
    {
        const encodedKey = encodeHtml(key);
        searchParameters.push(encodedKey);
        valueList[encodedKey] = encodeHtml(values[key]);
    }

    if (element.hasClass(classNames.returnValueListAsKeys))
    {
        return searchParameters;
    }

    return valueList;
}

export function clear(element: JQuery<HTMLElement>, suppressChange: boolean = false)
{
    let dmse = element;
    const checkControl = element.closest(`.${classNames.distinctMultiSelectEEL}`);
    if (checkControl.length > 0)
    {
        dmse = checkControl;
    }

    // all code for clearing DMSEs should be in the 'clearAll' event, and
    // the values should only be cleared with the skyward.controls.clearValue() function
    if (dmse.hasClass(classNames.eventsBound))
    {
        dmse.trigger("clearAll", suppressChange);
    }
    else
    {
        dmse.data("clear", suppressChange);
    }
}

function forEachSelectedValue(backingDataElement: JQuery<HTMLElement>, callback: (key: string, value: string) => void)
{
    const stringValue = backingDataElement.val();
    const valueList = JSON.parse(stringValue ? stringValue as string : "{}");

    for (const key in valueList)
    {
        callback(key, valueList[key]);
    }
}

export function getSearchParameters(element: JQuery<HTMLInputElement>)
{
    const searchParameters: string[] = [];

    forEachSelectedValue(element, function (key, _value)
    {
        searchParameters.push(key);
    });

    return searchParameters;
}
